
import {
  DESTINATION_KEY_BY_PROVIDER_NAME,
  DESTINATION_LABEL_BY_KEY,
} from 'mail-destination-config';

export const DEFAULT_DESTINATION_LABELS = DESTINATION_LABEL_BY_KEY;

export const LEGACY_NAME_TO_KEY = DESTINATION_KEY_BY_PROVIDER_NAME;

const titleCase = (str) => str
  .split(' ')
  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join(' ');

const getLabelList = (digestOrLabels) => {
  if (Array.isArray(digestOrLabels)) return digestOrLabels;
  const labels = digestOrLabels?.labels;
  return Array.isArray(labels) ? labels : [];
};

const labelForKey = (key, labels) => (
  labels.find(entry => entry?.key === key)?.label || DEFAULT_DESTINATION_LABELS[key]
);

export const resolveActionDestination = (action, digest) => {
  const meta = action?.metaData ?? {};
  const labels = getLabelList(digest);

  if (meta.destinationKey) {
    return {
      key: meta.destinationKey,
      label: meta.destinationLabel || labelForKey(meta.destinationKey, labels) || titleCase(meta.destinationKey.replace(/_/g, ' ')),
    };
  }

  const legacyName = (meta.labelId
    ? labels.find(entry => entry?.id === meta.labelId)?.name
    : undefined) ?? meta.labelName;

  if (!legacyName) return null;

  const key = LEGACY_NAME_TO_KEY[legacyName.toUpperCase()];
  return {
    key,
    label: (key && DEFAULT_DESTINATION_LABELS[key]) || titleCase(legacyName),
  };
};

export const resolveActionDestinationName = (action, digest) => {
  const destination = resolveActionDestination(action, digest);
  return destination?.key || destination?.label || '';
};
